import React from 'react';

function Metadata(props: React.SVGAttributes<{}>) {
    return (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <rect width="40" height="40" fill="white" />
            <path d="M27.8947 28.3337L36.6666 20.0003L27.8947 11.667M12.1052 11.667L3.33325 20.0003L12.1052 28.3337" stroke="#2E2E2E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M22.8171 10L17.3683 30" stroke="#2E2E2E" strokeWidth="2" strokeLinecap="round" />
        </svg>
    );
}

export default Metadata;
